(function () {
  'use strict';

    var root = document.querySelector('div.ac#ambra-club');
  if (!root) return;

  var GOAL = parseInt(root.getAttribute('data-goal'), 10) || 575;
  var RATE = 25;
  var MIN = 25;
  var RULE_ID = 56068;
  var ALL_URL = root.getAttribute('data-all-url') || '/collections/all';
  var FALLBACK_URL = '/apps/loyalty';

  function prefix() {
    var p = (window._ALConfig && window._ALConfig.proxy_path_prefix) || 'apps/loyalty';
    return '/' + String(p).replace(/^\/+|\/+$/g, '') + '/cp';
  }

  var api = {
    get: function (path) {
      return fetch(prefix() + path, { credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
    },
    post: function (path, body) {
      return fetch(prefix() + path, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
    }
  };

  function $(name) { return root.querySelector('[data-ac="' + name + '"]'); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function num(v) { var n = Number(v); return isFinite(n) ? n : 0; }
  function fmt(n) { return Math.round(n).toLocaleString('pl-PL'); }
  function zl(n) {
    var r = Math.round(n * 100) / 100;
    return r % 1 === 0 ? fmt(r) : r.toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function date(v) {
    if (!v) return '';
    var d = new Date(v);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('pl-PL', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }
  function nb(s) { return String(s).replace(/ /g, '&nbsp;'); }
  function kupony(n) {
    var m10 = n % 10, m100 = n % 100;
    if (n === 1) return 'kupon';
    if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return 'kupony';
    return 'kuponów';
  }
  function list(x) {
    if (Array.isArray(x)) return x;
    if (x && Array.isArray(x.content)) return x.content;
    if (x && Array.isArray(x.data)) return x.data;
    if (x && Array.isArray(x.rewards)) return x.rewards;
    return [];
  }
  function fixU(s) {
    if (s == null) return s;
    return String(s).replace(/u0([0-9A-Fa-f]{3})/g, function (m, h) { return String.fromCharCode(parseInt(h, 16)); });
  }

  var LACZ = 'Jeden kod na zamówienie. Kod z&nbsp;klubu nie łączy się z&nbsp;innymi kodami rabatowymi. Darmowa dostawa działa razem z&nbsp;nim.';
  var curTx = [];
  function amountOf(r) {
    var a = num(r.amount);
    if (a > 0) return a;
    var m = String(r.description || r.name || '').match(/(\d+(?:[.,]\d+)?)\s*zł/i);
    if (m) { var v = parseFloat(m[1].replace(',', '.')); if (v > 0) return v; }
    if (r.pointTransactionId != null) {
      var t = curTx.filter(function (x) { return String(x.id) === String(r.pointTransactionId); })[0];
      if (t) { var p = Math.abs(num(t.points)); if (p > 0) return Math.round(p * 100 / RATE) / 100; }
    }
    return 0;
  }

  function activeRewards(loyalty) {
    return list(loyalty && loyalty.rewards).filter(function (r) {
      var st = String(r.status || 'UNUSED').toUpperCase();
      if (st !== 'UNUSED' && st !== 'ACTIVE') return false;
      if (r.expireDate) {
        var d = new Date(r.expireDate);
        if (!isNaN(d.getTime()) && d.getTime() < Date.now()) return false;
      }
      return !!r.discountCode;
    }).sort(function (a, b) {
      return new Date(a.expireDate || 0).getTime() - new Date(b.expireDate || 0).getTime();
    });
  }

  function usedRewards(loyalty) {
    function ts(r) { return new Date(r.usedAt || r.updatedAt || r.expireDate || 0).getTime() || 0; }
    return list(loyalty && loyalty.rewards).filter(function (r) {
      return String(r.status || '').toUpperCase() === 'USED' && r.discountCode;
    }).sort(function (a, b) { return ts(b) - ts(a); }).slice(0, 3);
  }

  function usedList(used) {
    if (!used.length) return '';
    return '<div class="ac-used"><p class="ac-used__h">Wykorzystane kupony</p><ul>' + used.map(function (r) {
      var amt = amountOf(r);
      var when = date(r.usedAt || r.updatedAt);
      var info = 'wykorzystany' + (when ? ' ' + when : '') + (r.orderName ? ' w zamówieniu ' + esc(r.orderName) : '');
      return '<li><s>' + esc(r.discountCode) + '</s><span>' + (amt > 0 ? nb(zl(amt) + ' zł') + ' · ' : '') + info + '</span></li>';
    }).join('') + '</ul></div>';
  }

  function stateOf(pts, rewards, used) {
    if (pts >= MIN) return 'member';
    if (rewards.length >= 2) return 'twocoupons';
    if (rewards.length === 1) return 'coupon';
    if (pts > 0) return 'low';
    if (used && used.length) return 'used';
    return 'zero';
  }

  var MARK = '<span class="ac-card__mark"><span class="ac-card__ambra">AMBRA</span><span class="ac-card__club">CLUB</span></span>';

  var pendLine = '';
  function card(tag, mid, botLeft, botRight, label) {
    mid += pendLine;
    return '<div class="ac-card" role="group" aria-label="' + esc(label) + '">' +
      '<div class="ac-card__top">' + MARK + '<span class="ac-card__tag">' + tag + '</span></div>' +
      '<div>' + mid + '</div>' +
      '<div class="ac-card__bot"><span>' + esc(botLeft) + '</span><span class="ac-tn">' + botRight + '</span></div></div>';
  }

  function codeItem(r, single) {
    var code = esc(r.discountCode);
    if (single) {
      return '<div class="ac-code"><span class="ac-code__val">' + code + '</span>' +
        '<button class="ac-code__copy" type="button" data-ac-copy="' + code + '" aria-label="Kopiuj kod ' + code + '">Kopiuj kod</button></div>';
    }
    var amt = amountOf(r);
    var meta = (amt > 0 ? '<b>' + nb(zl(amt) + ' zł') + '</b>' : '<b>Kupon</b>') + (r.expireDate ? ' · ważny do ' + date(r.expireDate) : '');
    return '<li class="ac-code"><span class="ac-code__info"><span class="ac-code__val">' + code + '</span>' +
      '<span class="ac-code__meta ac-tn">' + meta + '</span></span>' +
      '<button class="ac-code__copy" type="button" data-ac-copy="' + code + '" aria-label="Kopiuj kod ' + code + '">Kopiuj</button></li>';
  }

  function codesList(rewards) {
    return '<ul class="ac-codes" aria-label="Twoje kody rabatowe">' + rewards.map(function (r) { return codeItem(r, false); }).join('') + '</ul>';
  }

  var last = null;

  function render(data, opts) {
    opts = opts || {};
    var loyalty = (data && data.loyalty) || {};
    var tx = list(data && data.transactions);
    curTx = tx;
    var name = root.getAttribute('data-name') || '';
    var pts = Math.max(0, Math.floor(num(loyalty.availablePoints)));
    var pend = Math.max(0, Math.floor(num(loyalty.pendingPoints)));
    var worth = Math.round(pts * 100 / RATE) / 100;
    var rewards = activeRewards(loyalty);
    var used = usedRewards(loyalty);
    var st = stateOf(pts, rewards, used);
    var exp = date(loyalty.pointsExpireAt);
    last = { pts: pts, worth: worth, data: data, hasCoupon: activeRewards(loyalty).length > 0 };

    root.setAttribute('data-state', st);
    if (pend > 0) root.setAttribute('data-pending', '1'); else root.removeAttribute('data-pending');

    var h1 = {
      member: 'Twoja karta <strong>klubu</strong>.',
      low: 'Twoja karta <strong>klubu</strong>.',
      coupon: 'Twój kupon jest <strong>gotowy</strong>.',
      twocoupons: 'Twoje kupony są <strong>gotowe</strong>.',
      zero: 'Witaj w <strong>klubie</strong>.',
      used: 'Kupon <strong>wykorzystany</strong>.'
    }[st];
    if (opts.justRedeemed && rewards.length) h1 = rewards.length > 1 ? h1 : 'Twój kupon jest <strong>gotowy</strong>.';
    $('h1').innerHTML = h1;

    pendLine = '';
    if (pend > 0) {
      var pTx = tx.filter(function (t) { return String(t.status || '').toUpperCase() === 'PENDING'; });
      var one = pTx.length === 1 && pTx[0].orderName && Math.round(num(pTx[0].points)) === pend;
      pendLine = '<p class="ac-card__pend ac-tn" style="font-size:13px;line-height:1.35;color:#6b6b6b;margin:8px 0 0">+' + nb(fmt(pend) + ' pkt') + ' oczekuje · ' +
        (one ? 'za zamówienie ' + esc(pTx[0].orderName) + ' po wysłaniu' : 'doliczymy po wysłaniu zamówienia') + '</p>';
    }
    var expTxt = exp ? 'Punkty ważne do ' + exp : 'Wymiana od 25 pkt';
    var html;
    if (st === 'member' || st === 'goal') {
      html = card('Do wymiany',
        '<div class="ac-card__pts"><span class="ac-num" aria-hidden="true">' + fmt(pts) + '</span><span class="ac-card__unit">pkt</span></div>' +
        '<p class="ac-card__worth">= <b>' + nb(zl(worth) + ' zł') + '</b> rabatu</p>',
        name, expTxt,
        'Karta AMBRA CLUB: ' + fmt(pts) + ' pkt, czyli ' + zl(worth) + ' zł rabatu.' + (exp ? ' Punkty ważne do ' + exp : ''));
    } else if (st === 'coupon') {
      var r1 = rewards[0], a1 = amountOf(r1);
      html = card('Kupon',
        (a1 > 0
          ? '<div class="ac-card__pts"><span class="ac-num" aria-hidden="true">' + zl(a1) + '<small>zł</small></span></div><p class="ac-card__worth">rabatu na <b>jedno</b> zamówienie</p>'
          : '<p class="ac-card__worth"><b>Twój kupon</b> na jedno zamówienie</p>'),
        name, r1.expireDate ? 'Kupon ważny do ' + date(r1.expireDate) : '',
        'Kupon AMBRA CLUB' + (a1 > 0 ? ': ' + zl(a1) + ' zł rabatu' : '') + (r1.expireDate ? ', ważny do ' + date(r1.expireDate) : ''));
    } else if (st === 'twocoupons') {
      var big = rewards.slice().sort(function (a, b) { return amountOf(b) - amountOf(a); })[0];
      var bigA = amountOf(big), moreN = rewards.length - 1;
      var moreTxt = 'i&nbsp;jeszcze ' + moreN + ' ' + kupony(moreN);
      html = card('Kupony',
        (bigA > 0
          ? '<div class="ac-card__pts"><span class="ac-num" aria-hidden="true">' + zl(bigA) + '<small>zł</small></span></div><p class="ac-card__worth">' + moreTxt + '</p>'
          : '<div class="ac-card__pts"><span class="ac-num" aria-hidden="true">' + rewards.length + '</span><span class="ac-card__unit">' + kupony(rewards.length) + '</span></div><p class="ac-card__worth">do wykorzystania</p>'),
        name, big.expireDate ? 'Kupon ważny do ' + date(big.expireDate) : '',
        'AMBRA CLUB: ' + rewards.length + ' ' + kupony(rewards.length) + ' do wykorzystania' + (bigA > 0 ? ', największy ' + zl(bigA) + ' zł' : ''));
    } else if (st === 'low') {
      html = card('Zbierasz',
        '<div class="ac-card__pts"><span class="ac-num" aria-hidden="true">' + fmt(pts) + '</span><span class="ac-card__unit">pkt</span></div>' +
        '<p class="ac-card__worth">Jeszcze <b>' + nb(fmt(MIN - pts) + ' pkt') + '</b> do pierwszego kuponu</p>' +
        '<div class="ac-prog" aria-hidden="true"><i style="width:' + Math.round(pts * 100 / MIN) + '%"></i></div>',
        name, expTxt,
        'Karta AMBRA CLUB: ' + fmt(pts) + ' pkt, brakuje ' + fmt(MIN - pts) + ' pkt do pierwszego kuponu');
    } else {
      html = card(st === 'used' ? 'Zbierasz' : 'Nowa karta',
        '<div class="ac-card__pts"><span class="ac-num ac-num--zero" aria-hidden="true">0</span><span class="ac-card__unit">pkt</span></div>' +
        '<p class="ac-card__worth">' + (st === 'used' ? 'Następne punkty przy kolejnych perfumach Ambra.' : 'Pierwsze punkty przy najbliższych perfumach.') + '</p>',
        name, 'Wymiana od 25 pkt', st === 'used' ? 'Karta AMBRA CLUB: 0 pkt, kupon wykorzystany' : 'Karta AMBRA CLUB: jeszcze bez punktów');
    }
    $('stage').innerHTML = html;

    var future = '';
    if (pend > 0) {
      var fut = pts + pend;
      future = 'Po wysłaniu zamówienia będziesz mieć ' + nb(fmt(fut) + ' pkt') + (fut >= MIN ? ', czyli kupon ' + nb(zl(Math.round(fut * 100 / RATE) / 100) + ' zł') : '') + '.';
    }
    var more = 'Kolejne perfumy Classic i&nbsp;UNIQ w&nbsp;cenie regularnej dołożą punkty.';
    var cta = '';
    if (opts.notice) cta += '<p class="ac-note" role="status">' + opts.notice + '</p>';
    if (st === 'member' || st === 'goal') {
      cta += '<div class="ac-mhero__cta" data-ac="redeem-wrap"><button type="button" class="ac-btn ac-btn--light" data-ac-redeem>Wymień punkty na kupon</button></div>';
      cta += st === 'goal'
        ? '<p class="ac-mhero__fine">Kupon obejmie wszystkie punkty naraz. Bez minimalnej kwoty zamówienia, ważny 90&nbsp;dni od wymiany.</p>'
        : '<p class="ac-mhero__fine">Wymieniasz już od 25&nbsp;pkt, a&nbsp;dziś Twoje ' + nb(fmt(pts) + ' pkt') + ' to ' + nb(zl(worth) + ' zł') + ' rabatu. Kupon obejmie wszystkie punkty naraz.</p>';
      if (rewards.length) {
        cta += '<p class="ac-codes-h">Twoje kupony</p>' + codesList(rewards) + '<p class="ac-mhero__fine">' + LACZ + '</p>';
        cta += '<p class="ac-redeem2"><a class="ac-link" href="' + esc(ALL_URL) + '">Wybierz perfumy</a></p>';
      }
    } else if (st === 'coupon') {
      cta += codeItem(rewards[0], true);
      cta += '<p class="ac-mhero__fine">Wpisz kod przy składaniu zamówienia. Działa raz, na perfumy Classic, UNIQ i&nbsp;zestawy, bez minimalnej kwoty. Kod z&nbsp;klubu nie łączy się z&nbsp;innymi kodami rabatowymi. Darmowa dostawa działa razem z&nbsp;nim.</p>';
      cta += '<div class="ac-mhero__cta"><a class="ac-btn ac-btn--light" href="' + esc(ALL_URL) + '">Wybierz perfumy</a></div>';
    } else if (st === 'twocoupons') {
      cta += codesList(rewards);
      cta += '<p class="ac-mhero__fine">' + LACZ + '</p>';
      cta += '<div class="ac-mhero__cta"><a class="ac-btn ac-btn--light" href="' + esc(ALL_URL) + '">Wybierz perfumy</a></div>';
    } else if (st === 'low') {
      cta += '<div class="ac-mhero__cta"><span class="ac-btn" aria-disabled="true">Wymiana od 25 pkt</span></div>';
      cta += '<p class="ac-mhero__fine">' + (future || more) + '</p>';
    } else {
      cta += '<div class="ac-mhero__cta"><a class="ac-btn ac-btn--light" href="' + esc(ALL_URL) + '">Zobacz perfumy Ambra</a></div>';
      cta += '<p class="ac-mhero__fine ac-tn">' + (future || (st === 'used' ? more : '1&nbsp;pkt za każdą pełną złotówkę, wymiana na kupon już od 25&nbsp;pkt.')) + '</p>';
    }
    $('cta').innerHTML = cta;

    var cp = $('close-pts'), cz = $('close-zl');
    if (cp) cp.textContent = fmt(pts);
    if (cz) cz.textContent = zl(worth);

    renderHistory(tx, pts, st, used);
    renderScale(tx, pts);
  }

  function renderScale(tx, pts) {
    var sec = $('scale'), body = $('scale-body');
    if (!sec || !body) return;
    var conv = tx.some(function (t) { return /przelicz/i.test(String(t.note || t.description || '')); });
    var zlv = Math.floor(pts / RATE);
    if (!conv || zlv < 1) { sec.hidden = true; return; }
    var step = Math.ceil(zlv / 10), n = Math.ceil(zlv / step);
    var cols = 'grid-template-columns:repeat(' + n + ',1fr)';
    var cells = '', labels = '';
    for (var i = 1; i <= n; i++) { cells += '<i></i>'; labels += '<span>' + nb(fmt(Math.min(i * step, zlv)) + ' zł') + '</span>'; }
    function ruler(lab, val, cls) {
      return '<div class="ac-ruler ac-reveal"><div class="ac-ruler__head"><span class="ac-ruler__lab">' + lab + '</span><span class="ac-ruler__val">' + val + '</span></div>' +
        '<div class="ac-bar ' + cls + '" style="' + cols + '" aria-hidden="true">' + cells + '</div>' +
        '<div class="ac-bar__zl" style="' + cols + '" aria-hidden="true">' + labels + '</div></div>';
    }
    function val(a, b) { return fmt(a) + '<small>&nbsp;pkt</small> = ' + fmt(b) + '<small>&nbsp;zł</small>'; }
    body.innerHTML = ruler('Wcześniej', val(zlv, zlv), 'ac-bar--old') + ruler('Teraz', val(zlv * RATE, zlv), 'ac-bar--new') +
      '<div class="ac-scale__out ac-reveal"><p>Każdy dawny punkt to teraz <b>25&nbsp;punktów</b>. Saldo nic nie traci: na przykład ' +
      nb(fmt(zlv) + ' pkt') + ' było wartych ' + nb(fmt(zlv) + ' zł') + ', a&nbsp;' + nb(fmt(zlv * RATE) + ' pkt') + ' jest wartych ' + nb(fmt(zlv) + ' zł') + '.</p></div>';
    sec.hidden = false;
  }

  function statusLabel(s) {
    s = String(s || '').toUpperCase();
    if (s === 'APPROVED' || s === 'COMPLETED' || s === 'SUCCESS') return 'Zatwierdzone';
    if (s === 'PENDING') return 'Oczekujące';
    if (s === 'REJECTED' || s === 'CANCELLED' || s === 'CANCELED' || s === 'EXPIRED' || s === 'REVERTED') return 'Anulowane';
    return s ? s.charAt(0) + s.slice(1).toLowerCase() : '';
  }

  function renderHistory(tx, pts, st, used) {
    var rows = tx.slice(0, 20).map(function (t) {
      var note = fixU(t.note), descr = fixU(t.description);
      var p = Math.abs(Math.round(num(t.points)));
      var debit = String(t.pointType || '').toUpperCase() === 'DEBIT' || num(t.points) < 0;
      var what = t.orderName ? 'Zamówienie ' + t.orderName : (note || descr || (debit ? 'Wymiana na kupon' : 'Punkty'));
      var sub = date(t.createAt || t.createdAt || t.createdDate);
      return '<div class="ac-hist__row"><span class="ac-hist__what">' + esc(what) + '</span>' +
        '<span class="ac-hist__date">' + (esc(sub) || '&nbsp;') + '</span>' +
        '<span class="ac-hist__pts">' + (debit ? '−' : '+') + nb(fmt(p) + ' pkt') + '<small>' + esc(statusLabel(t.status)) + '</small></span></div>';
    });
    if (!rows.length) {
      rows.push('<div class="ac-hist__row"><span class="ac-hist__what">Jeszcze bez wpisów. Pierwszy pojawi się po zamówieniu perfum Ambra.</span><span class="ac-hist__date">&nbsp;</span><span class="ac-hist__pts">0&nbsp;pkt</span></div>');
    }
    $('hist').innerHTML = rows.join('');
    var sum;
    if (pts >= MIN) sum = '<span>Do wymiany teraz</span><b>' + nb(fmt(pts) + ' pkt') + ' = ' + nb(zl(Math.round(pts * 100 / RATE) / 100) + ' zł') + '</b>';
    else if (pts > 0) sum = '<span>Do wymiany od</span><b>25&nbsp;pkt</b>';
    else if (st === 'zero' || st === 'used') sum = '';
    else sum = '<span>Do wymiany teraz</span><b>0&nbsp;pkt</b>';
    $('sum').innerHTML = (sum ? '<div class="ac-hist__sum ac-tn">' + sum + '</div>' : '') + usedList(used || []);
  }

  function renderError() {
    root.setAttribute('data-state', 'error');
    $('h1').innerHTML = 'Twoja karta <strong>klubu</strong>.';
    $('stage').innerHTML = '';
    var msg = '<p class="ac-err" role="alert">Nie udało się teraz wczytać Twoich punktów. Odśwież stronę za chwilę albo zobacz je na <a href="' + FALLBACK_URL + '">stronie programu AMBRA CLUB</a>.</p>';
    $('cta').innerHTML = msg;
    $('hist').innerHTML = '<div class="ac-hist__row"><span class="ac-hist__what">Historia chwilowo niedostępna.</span><span class="ac-hist__date"><a href="' + FALLBACK_URL + '">Zobacz na stronie programu</a></span><span class="ac-hist__pts">&nbsp;</span></div>';
    $('sum').innerHTML = '';
    if ($('scale')) $('scale').hidden = true;
  }

  function load(opts) {
    return Promise.all([
      api.get('/api/customer-loyalty?status=UNUSED,USED').catch(function () { return api.get('/api/customer-loyalty?status=UNUSED'); }),
      api.get('/api/transaction-by-shop?page=0&size=10&sort=createAt,desc').catch(function () { return []; })
    ]).then(function (res) {
      render({ loyalty: res[0], transactions: res[1] }, opts);
    }).catch(function (e) {
      if (window.console) console.warn('[AMBRA CLUB]', e);
      renderError();
    });
  }

  function openConfirm() {
    if (!last || last.pts < MIN) return;
    var wrap = $('redeem-wrap');
    if (!wrap) return;
    wrap.outerHTML = '<div class="ac-confirm" data-ac="confirm" role="group" aria-label="Potwierdzenie wymiany">' +
      '<p>Zamienisz <b>' + nb(fmt(last.pts) + ' pkt') + '</b> na kupon <b>' + nb(zl(last.worth) + ' zł') + '</b>.</p>' +
      '<small>Kupon działa raz i&nbsp;jest ważny 90&nbsp;dni. Tej zamiany nie da się cofnąć. Licznik punktów zacznie się od zera.' + (last.hasCoupon ? ' Powstanie drugi kod. W&nbsp;jednym zamówieniu wpiszesz jeden kod, więc drugi zostanie na kolejne zakupy.' : '') + '</small>' +
      '<div class="ac-confirm__btns"><button type="button" class="ac-btn ac-btn--light" data-ac-confirm>Potwierdź</button>' +
      '<button type="button" class="ac-link" data-ac-cancel>Anuluj</button></div></div>';
    var b = root.querySelector('[data-ac-confirm]');
    if (b) b.focus();
  }

  function doRedeem(btn) {
    btn.disabled = true;
    btn.textContent = 'Wymieniam…';
    var cancel = root.querySelector('[data-ac-cancel]');
    if (cancel) cancel.disabled = true;
    api.post('/api/redeem-points', { redeemRuleId: RULE_ID, points: last.pts }).then(function () {
      return load({ justRedeemed: true, notice: 'Gotowe. Skopiuj kod poniżej i&nbsp;wpisz go przy zamówieniu.' });
    }).then(function () {
      var top = root.querySelector('.ac-mhero');
      if (top && top.scrollIntoView) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }).catch(function (e) {
      if (window.console) console.warn('[AMBRA CLUB] redeem', e);
      var c = $('confirm');
      if (c) c.outerHTML = '<p class="ac-err" role="alert">Wymiana się nie udała, punkty zostały na karcie. Spróbuj ponownie za chwilę albo wymień je na <a href="' + FALLBACK_URL + '">stronie programu AMBRA CLUB</a>.</p>';
    });
  }

  function copy(btn) {
    var code = btn.getAttribute('data-ac-copy');
    var done = function () {
      var t = btn.textContent;
      btn.textContent = 'Skopiowano';
      setTimeout(function () { btn.textContent = t; }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, function () { fallbackCopy(code); done(); });
    } else { fallbackCopy(code); done(); }
  }
  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('button') : null;
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-ac-copy')) { copy(t); return; }
    if (t.hasAttribute('data-ac-redeem')) {
      if (!$('redeem-wrap') && !$('confirm')) return;
      var top = root.querySelector('.ac-mhero');
      if (top && t.closest('.ac-close') && top.scrollIntoView) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
      openConfirm();
      return;
    }
    if (t.hasAttribute('data-ac-cancel')) { render(last.data); return; }
    if (t.hasAttribute('data-ac-confirm')) { doRedeem(t); }
  });

  window.AmbraClub = { render: render, renderError: renderError, load: load, api: api, root: root };

  if (root.getAttribute('data-state') === 'loading') load();
})();
